<template>
  <div class="stat-card" :style="{ '--accent-color': color }">
    <div class="stat-card-icon" :style="{ color, background: iconBg }">
      <i :class="icon"></i>
    </div>
    <div class="stat-card-content">
      <div class="stat-card-title">{{ title }}</div>
      <div class="stat-card-metrics">
        <div class="metric-item">
          <span class="metric-label">今日</span>
          <div class="stat-card-value">
            <span class="value">{{ formattedToday }}</span>
            <span class="unit">{{ unit }}</span>
          </div>
        </div>
        <div class="metric-divider"></div>
        <div class="metric-item">
          <span class="metric-label">年累计</span>
          <div class="stat-card-value sub-value">
            <span class="value">{{ formattedAnnual }}</span>
            <span class="unit">{{ annualUnit }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from '@/utils/format'

export default {
  name: 'StatCard',
  props: {
    title: String,
    today: Number,
    annual: Number,
    unit: String,
    annualUnit: String,
    icon: String,
    color: { type: String, default: '#409EFF' }
  },
  computed: {
    formattedToday() {
      return formatNumber(this.today, 2)
    },
    formattedAnnual() {
      return formatNumber(this.annual, 2)
    },
    iconBg() {
      return `${this.color}14`
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.stat-card {
  background: @card-bg;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(26, 58, 92, 0.04), 0 4px 16px rgba(26, 58, 92, 0.06);
  padding: 14px 16px;
  border: 1px solid rgba(228, 231, 237, 0.8);
  display: flex;
  gap: 12px;
  min-height: 96px;
  position: relative;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: var(--accent-color, @active-color);
    border-radius: 10px 10px 0 0;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(26, 58, 92, 0.06), 0 8px 24px rgba(26, 58, 92, 0.1);
  }

  .stat-card-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .stat-card-content {
    flex: 1;
    min-width: 0;
  }

  .stat-card-title {
    font-size: 13px;
    font-weight: 500;
    color: @text-secondary;
    margin-bottom: 8px;
  }

  .stat-card-metrics {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .metric-item {
    flex: 1;
    min-width: 0;
  }

  .metric-label {
    display: block;
    font-size: 11px;
    color: #c0c4cc;
    margin-bottom: 2px;
  }

  .metric-divider {
    width: 1px;
    height: 28px;
    background: @border-color;
    flex-shrink: 0;
  }

  .stat-card-value {
    .value {
      font-size: 17px;
      font-weight: 700;
      color: @text-primary;
      letter-spacing: -0.02em;
    }

    .unit {
      font-size: 11px;
      color: @text-secondary;
      margin-left: 3px;
    }

    &.sub-value .value {
      font-size: 14px;
      font-weight: 600;
      color: #606266;
    }
  }
}
</style>
